import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import ConsumableEditForm from '@components/shared/consumables/ConsumableEdit';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import useOperatorConsumableService from '@hooks/operator/consumables/useOperatorConsumableService';

function ConsumableNewContent() {
  const consumableService = useOperatorConsumableService();
  const { volumeUnit } = useOperatorData();

  return (
    <ConsumableEditForm
      loadConsumable={consumableService.get}
      createConsumable={consumableService.create}
      updateConsumable={consumableService.update}
      volumeUnit={volumeUnit}
      role="operator"
    />
  );
}

export default function OperatorConsumableNew() {
  // 新增模式：先選擇 merchant
  return (
    <MerchantSelect>
      <ConsumableNewContent />
    </MerchantSelect>
  );
}
